import Wallet from "./wallet.view";

export default Wallet;
